import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

/**
 * @typedef MenuOptions
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, content: string }} [overlay] Mobile menu dialog and the slot the navigation moves into
 */

const MainMenu = {
    selector: '#header .main-nav',
    navButton: '#header .nav-button',
    overlay: {
        element: '#nav-overlay',
        content: '#nav-content',
    },
};

onDomReady(() => {
    new DropdownMenu(MainMenu);
});
